module.exports = __webpack_public_path__ + "img/wallet.f38801ff.svg";